import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent } from '@/components/ui/card';
import { Wallet, Building2, FileCheck, AlertCircle } from 'lucide-react';

const IncomeProof = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate('/knowledge-base/documentation')}
          className="text-primary hover:text-primary/80 transition-colors mb-8 flex items-center"
        >
          ← Back to Documentation
        </button>

        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-4">
            Proof of Income Documentation
          </h1>
          <p className="text-muted-foreground">
            Guide to preparing and submitting financial documents to prove sufficient means of support for your stay in Poland.
          </p>
        </div>

        <div className="space-y-8">
          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Wallet className="h-5 w-5 text-primary mr-2" />
                Required Income Level
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Minimum monthly income requirement for single person
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Additional requirements for family members
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Savings requirements if no regular income
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Building2 className="h-5 w-5 text-primary mr-2" />
                Employment Documentation
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <FileCheck className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Employment contract (umowa o pracę)
                </li>
                <li className="flex items-start">
                  <FileCheck className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Recent pay slips (minimum 3 months)
                </li>
                <li className="flex items-start">
                  <FileCheck className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Bank statements showing salary deposits
                </li>
                <li className="flex items-start">
                  <FileCheck className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Tax returns (PIT) if applicable
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <AlertCircle className="h-5 w-5 text-primary mr-2" />
                Self-Employed Requirements
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Company registration documents
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Business bank statements (6 months)
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Profit and loss statements
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Tax clearance certificate
                </li>
              </ul>
            </CardContent>
          </Card>

          <div className="bg-accent p-6 rounded-lg border border-border">
            <h2 className="text-xl font-semibold text-foreground mb-2">Need Financial Documentation Assistance?</h2>
            <p className="text-muted-foreground mb-4">
              Our financial experts can help you prepare the required documentation and ensure it meets all criteria.
            </p>
            <button 
              onClick={() => navigate('/contact')}
              className="bg-primary text-primary-foreground px-6 py-2 rounded-lg hover:bg-primary/90 transition-colors"
            >
              Get Expert Help
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncomeProof; 